// redux/features/meeting-minute-logs-slice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import api from '@/axiosSetup';
import { IMeetingMinuteRecord } from '../../../types/IMeetingMinuteRecord';

interface MeetingMinuteRecordState {
  records: IMeetingMinuteRecord[];
  loading: boolean;
  error: string | null;
}

const initialState: MeetingMinuteRecordState = {
  records: [],
  loading: false,
  error: null,
};

export const fetchMeetingMinuteRecords = createAsyncThunk(
  'meetingMinuteRecords/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get<IMeetingMinuteRecord[]>('/api/meeting-minute-records');
      return res.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch meeting minute records'
      );
    }
  }
);

const meetingMinuteRecordSlice = createSlice({
  name: 'meetingMinuteRecords',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMeetingMinuteRecords.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMeetingMinuteRecords.fulfilled, (state, action: PayloadAction<IMeetingMinuteRecord[]>) => {
        state.records = action.payload;
        state.loading = false;
      })
      .addCase(fetchMeetingMinuteRecords.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default meetingMinuteRecordSlice.reducer;